import { AssigneeOption } from '@user/store/salesTeam/typings'
import { SalespersonFilterOption } from '@user/store/map/typings'
import { ServiceConfig } from '@user/store/services/config'
import { post } from '@user/store/services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}/salesTeam/getUsersByTeamStructure`

export const getUserListForSalesTeamsByStructure = async (
  ids: number[],
): Promise<AssigneeOption[] | undefined> => {
  if (ids && !!ids.length) {
    try {
      const response = await post(`${baseUrl}`, ids)

      if (response.ok) {
        const userList: AssigneeOption[] = await response.json()

        return userList.map((x) => ({
          id: x.userId,
          userId: x.userId,
          name: x.name,
          isActive: x.isActive,
        }))
      } else {
        return []
      }
    } catch {
      return undefined
    }
  } else {
    return []
  }
}

// Unlike getUserListForSalesTeamsByStructure above, this does NOT short-circuit
// on an empty ids array: for an Admin caller, restrictToMapPicklist=true makes
// the backend ignore salesTeamIds entirely and return the full org-wide set
// (per Unit 1), so an empty array is a legitimate request that must still reach
// the backend, not a "nothing to fetch" signal.
export const getSalespersonFilterPicklist = async (
  salesTeamIds: number[],
): Promise<SalespersonFilterOption[] | undefined> => {
  try {
    // crud.ts's post() omits the request body entirely for an empty array
    // (`Object.keys(data).length` is 0), which ASP.NET Core's [FromBody]
    // binder rejects with 400. The `options` override is spread after the
    // computed body, so this forces the real (possibly empty) JSON array
    // through regardless — without changing the shared crud helper.
    const response = await post(
      `${baseUrl}?restrictToMapPicklist=true`,
      salesTeamIds,
      { body: JSON.stringify(salesTeamIds) },
    )

    if (response.ok) {
      const userList: SalespersonFilterOption[] = await response.json()
      return userList.map((x) => ({
        userId: x.userId,
        name: x.name,
        isActive: x.isActive,
        isAdmin: x.isAdmin,
        hasMapActivity: x.hasMapActivity,
      }))
    }
    return []
  } catch {
    return undefined
  }
}
